// extracted by mini-css-extract-plugin
export default {"flowsheetLayoutContainer":"Flowsheet_flowsheetLayoutContainer__JBRlq"};